import { InquiryQueueFilter, InquiryScope, TemplateLanguage } from "./types";
import { INK } from "./styles";

export const QUEUE_LABELS: Record<InquiryQueueFilter, string> = {
  needs_reply: "Needs reply",
  replied: "Waiting for buyer",
  offer_pending: "Offers",
  closed: "Closed",
  all: "All",
};

export const LANGUAGE_NAMES: Record<TemplateLanguage, string> = {
  en: "English",
  de: "German",
  fr: "French",
  es: "Spanish",
};

export const TAB_LABELS = { needs_reply: "Needs reply", replied: "Waiting" } as const;

export const SCOPE_LABELS: Record<InquiryScope, string> = {
  anyone: "Anyone",
  mine: "Mine",
  unassigned: "Unassigned",
};

const REASON_LABELS: Record<string, string> = {
  MERCHANDISE_OR_SERVICE_NOT_RECEIVED: "Not received",
  MERCHANDISE_OR_SERVICE_NOT_AS_DESCRIBED: "Not as described",
};

export function reasonLabel(reason: string | null): string {
  if (!reason) return "";
  if (REASON_LABELS[reason]) return REASON_LABELS[reason];
  const words = reason.replace(/_/g, " ").toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

const STATUS_LABELS: Record<string, string> = {
  WAITING_FOR_SELLER_RESPONSE: "Waiting for seller",
  WAITING_FOR_BUYER_RESPONSE: "Waiting for buyer",
  UNDER_REVIEW: "Under review",
  REFUNDED: "Refunded",
  PARTIALLY_REFUNDED: "Partially refunded",
  CANCELLED: "Cancelled by buyer",
};

export function paypalStatusLabel(status: string | null, outcomeCode: string | null = null): string {
  if (!status) return "";
  if (status === 'RESOLVED') {
    if (outcomeCode?.includes('SELLER_FAVOUR')) return "Resolved, seller favour";
    if (outcomeCode?.includes('BUYER_FAVOUR')) return "Resolved, buyer favour";
    return "Resolved";
  }
  return STATUS_LABELS[status] ?? status.replace(/_/g, " ");
}

export function formatWaiting(waited: number): string {
  const hours = Math.max(0, waited);
  if (hours >= 24) return `${Math.floor(hours / 24)}d`;
  if (hours >= 1) return `${Math.floor(hours)}h`;
  return `${Math.floor(hours * 60)}m`;
}

export function formatTimeLeft(hoursLeft: number): string {
  if (hoursLeft < 0) return "overdue";
  if (hoursLeft >= 24) return `${Math.floor(hoursLeft / 24)}d left`;
  if (hoursLeft >= 1) return `${Math.floor(hoursLeft)}h left`;
  return `${Math.floor(hoursLeft * 60)}m left`;
}

export function timeLeftColor(hoursLeft: number): string {
  if (hoursLeft < 48) return INK.danger;
  if (hoursLeft < 120) return '#b54708';
  return INK.muted;
}
